import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { GA_MEASUREMENT_ID } from '@app/constants';

const gtag: Function = window['gtag'];
@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
    constructor() { }

    public eventEmitter(
        eventName: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string = '',
        eventValue: number = null
    ): void {
        if (!window['gtag']) { return; }
        const category = !eventCategory || eventCategory.trim() === '' ? 'screenName' : eventCategory;
        const label = `${eventLabel ? eventLabel.trim() : ''} ${this.getLabelExtraInfo()}`;
        window['gtag'](
            'event',
            eventName,
            {
                eventCategory: category,
                eventLabel: label,
                eventAction: eventAction,
                eventValue: eventValue,
            }
        );
    }

    public trackErrorExceptions(errorMsj: string, isFatal: boolean): void {
        if (!window['gtag']) { return; }
        const errorMessage = `${errorMsj} - ${this.getLabelExtraInfo()}`;
        window['gtag'](
            'event',
            'exception',
            {
                description: errorMessage,
                fatal: isFatal,
            }
        );
    }

    public trackNavigation(url: string): void {
        if (!window['gtag']) {
            console.info(`Google Analytics turned off. Url to track ${url}`);
            return;
        }
        console.info(`Google Analytics turned on. Url to track ${url}`);
        window['gtag'](
            'config',
            GA_MEASUREMENT_ID,
            {
                page_path: url,
            }
        );
    }

    private getLabelExtraInfo(): string {
        const transactionId = 0;
        return `TransactionId: ${transactionId}, Time: ${Math.floor((new Date()).getTime() / 1000)}`;
    }
}
